import PropTypes from 'prop-types';
import Commons from '../../helpers/Commons';

const PropertyDetailsSection = ({ titleDetails }) => {
    const titleDescription = titleDetails?.titles?.[0]?.titleDescription || {};
    const legalDescriptions = titleDetails?.titles?.[0]?.legalDescriptions || [];
    const parcels = titleDetails?.legal?.parcels?.[0] || {};
    const dashIfEmpty = (val, func) => {
        if (!val) return '-';
        try {
            if (func) return func(val);
        } catch (e) {
            console.error(e);
        }
        return val;
    };
    const convertHectareToMeter = (hectare) => {
        if (hectare >= 1) return `${hectare} Ha`
        return `${Math.round(hectare * 10000).toLocaleString()} m²`;
    }
    const formatDate = (date) => Commons.formatDate(date, 'DD MMM YYYY');

    return (
        <div>
            <table width="100%">
                <tbody>
                    <tr>
                        <td width="20%" className="property-label">Document Type:</td>
                        <td width="30%">{dashIfEmpty(titleDescription?.type)}</td>
                        <td width="20%" className="property-label">Reference:</td>
                        <td width="30%">{dashIfEmpty(titleDescription?.reference)}</td>
                    </tr>
                    <tr>
                        <td className="property-label">Date Issued:</td>
                        <td>{dashIfEmpty(titleDescription?.issueDate, formatDate)}</td>
                        <td className="property-label">Territory Authority:</td>
                        <td>{dashIfEmpty(parcels?.landAuthority)}</td>
                    </tr>
                    <tr>
                        <td className="property-label">Total Land Area:</td>
                        <td>{dashIfEmpty(parcels?.area)}</td>
                        <td className="property-label">Status:</td>
                        <td>Live</td>
                    </tr>
                </tbody>
            </table>
            <table width="100%" style={{ marginTop: 15 }}>
                <thead>
                    <tr>
                        <th width="50%" className="property-label">Legal Description</th>
                        <th className="property-label">Estate Type</th>
                        <th className="property-label">Estate Share</th>
                        <th className="property-label">Land Area</th>
                    </tr>
                </thead>
                <tbody>
                {
                    legalDescriptions?.map(({ description, estateType, estateShare, totalArea }) => (
                        <tr key={`${description}-${estateType}-${estateShare}-${totalArea}`}>
                            <td>{dashIfEmpty(description)}</td>
                            <td>{dashIfEmpty(estateType)}</td>
                            <td>{dashIfEmpty(estateShare)}</td>
                            <td>{dashIfEmpty(totalArea, convertHectareToMeter)}</td>
                        </tr>
                    ))
                }
                </tbody>
            </table>
        </div>
    );
};

PropertyDetailsSection.propTypes = {
    titleDetails: PropTypes.object,
};

export default PropertyDetailsSection;